import { api } from '@shared-runtime/api';

import type {
  FiatBankAccountsParams,
  FiatBankAccountsResult,
} from './apiSchema';
import { normalizeFiatBankAccounts } from './helpers';
import type { FiatBankAccountsResponse } from './schema';

export async function fetchFiatBankAccounts(
  params: FiatBankAccountsParams,
): Promise<FiatBankAccountsResponse> {
  return api.nts
    .get<FiatBankAccountsResult>('/fiat/get-accounts', { params })
    .normalize(normalizeFiatBankAccounts);
}
